import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const TransactionTypeChangeModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  type, onTypeChange, typeError, setTypeError, creditTransactionTypeList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Change transaction type'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputSelectSF type='select' name='type' label='Transaction type'
      value={type} onChange={onTypeChange} optionList={creditTransactionTypeList}
      error={typeError} setError={setTypeError}
    />
  </ModalFormUI>

export default TransactionTypeChangeModalUI
